export const mainCtaLabel = "Je veux les 2 livres + les 5 bonus pour 27 $ US";
export const pageTitle = "Le Maître de la Guitare™ — 2 livres + 5 bonus pour professeurs de guitare";

export const heroImage = "https://cdn.magicpatterns.com/uploads/e2vwsVuytGc96z6h2ushRD/Paquete_premium_para_profesores_de_guitarra.png";

export const usageSteps = [
  { title: "Ouvrez", desc: "Ouvrez le livre théorique ou le bonus dont vous avez besoin. Tout est en PDF, sur votre ordinateur, votre tablette ou votre téléphone." },
  { title: "Choisissez", desc: "Choisissez la notion, l'exercice, la tablature ou la fiche de cours adaptée au niveau de votre élève." },
  { title: "Enseignez", desc: "Imprimez la page ou affichez-la sur tablette, et apportez-la à votre prochain cours." },
];

export const lessonTimeline = [
  { time: "17 h 00", text: "Votre élève débutant arrive à 18 h." },
  { time: "17 h 01", text: "Vous ouvrez le livre théorique à la notion du jour pour revoir votre explication." },
  { time: "17 h 03", text: "Vous imprimez l'exercice du livre pratique et une tablature de la bibliothèque pour débuter." },
  { time: "17 h 05", text: "Vous prenez une fiche de cours prête à l'emploi avec les devoirs. Votre cours est prêt." },
];

export const pains = [
  "Vous passez des heures sur YouTube et les sites de tablatures à chercher quoi enseigner.",
  "Vous redistribuez les mêmes fiches d'accords parce que vous n'avez plus de matériel nouveau.",
  "Vous arrivez en cours sans savoir exactement ce que vous allez faire.",
  "Vos élèves s'ennuient et abandonnent avant leur premier morceau.",
];

export const books = [
  {
    label: "LIVRE 1 · POUR VOUS",
    title: "Le livre théorique",
    subtitle: "Votre guide du professeur",
    desc: "Ouvrez-le pour revoir une notion et préparer votre explication avant le cours.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/a763eed1-c019-4e10-842a-6c66068c639a.jpg",
  },
  {
    label: "LIVRE 2 · POUR VOS ÉLÈVES",
    title: "Le livre pratique",
    subtitle: "Pour faire travailler vos élèves",
    desc: "Choisissez un exercice, imprimez-le et faites-le travailler en cours.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/4b62b9da-435c-4386-ab50-fd5985bb4fd1.jpg",
  },
];

export const bonuses = [
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/e5616766-9fcc-43b8-8e77-ace9082cfc69.jpg",
    title: "La bibliothèque de tablatures pour débuter",
    desc: "Une collection de tablatures accessibles aux débutants, prêtes à imprimer et à distribuer dès le premier cours.",
    use: "imprimez une tablature et donnez-la à votre élève.",
  },
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/0b82cd07-27a7-4c7f-82eb-847ce4d917c5.jpg",
    title: "Le guide des mélodies pour débutants",
    desc: "Des mélodies simples pour que les nouveaux élèves jouent quelque chose de reconnaissable dès les premières semaines.",
    use: "choisissez une mélodie pour finir le cours sur une note motivante.",
  },
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/68f20178-b5c0-413f-a91d-3cd598c183c6.jpg",
    title: "Le calendrier d'exercices sur 30 jours",
    desc: "Un plan de pratique jour par jour à imprimer et à envoyer à la maison.",
    use: "donnez-le à votre élève pour qu'il progresse entre deux cours.",
  },
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/001dc7ab-c103-411a-ba00-557c6ca96d11.jpg",
    title: "Le pack d'exercices techniques",
    desc: "Des exercices ciblés de doigté, de médiator et de changements d'accords, classés par niveau de difficulté.",
    use: "choisissez l'exercice du niveau de votre élève pour l'échauffement.",
  },
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/3aabd506-d90f-437d-a14c-cbffb53a835e.jpg",
    title: "Les fiches de cours prêtes à l'emploi",
    desc: "Des fiches avec objectifs, exercices et devoirs.",
    use: "imprimez la fiche telle quelle ou adaptez-la à votre élève.",
  },
];

export const offerList = [
  "Le livre théorique — le guide du professeur",
  "Le livre pratique — pour vos élèves",
  "Bonus 01 · La bibliothèque de tablatures pour débuter",
  "Bonus 02 · Le guide des mélodies pour débutants",
  "Bonus 03 · Le calendrier d'exercices sur 30 jours",
  "Bonus 04 · Le pack d'exercices techniques",
  "Bonus 05 · Les fiches de cours prêtes à l'emploi",
  "Tout en PDF à télécharger et à imprimer",
];

export const testimonialPlaceholders = [
  { name: "[Prénom N.]", role: "[Rôle]", quote: "[Témoignage réel de client]" },
  { name: "[Prénom N.]", role: "[Rôle]", quote: "[Témoignage réel de client]" },
  { name: "[Prénom N.]", role: "[Rôle]", quote: "[Témoignage réel de client]" },
];

export const faqs = [
  { q: "Comment l'utiliser en cours ?", a: "C'est simple : ouvrez le livre théorique pour préparer votre explication, choisissez un exercice dans le livre pratique ou dans les bonus, imprimez-le et apportez-le à votre cours. Vous pouvez aussi l'afficher sur tablette." },
  { q: "Est-ce un livre physique ? Quel est le format ?", a: "C'est 100 % numérique, en PDF — sans vidéos ni livres audio. Les 2 livres et les 5 bonus sont des PDF que vous recevez par e-mail, à télécharger et à imprimer." },
  { q: "Que contient exactement le pack ?", a: "Le livre théorique, le livre pratique et 5 bonus offerts : la bibliothèque de tablatures pour débuter, le guide des mélodies pour débutants, le calendrier d'exercices sur 30 jours, le pack d'exercices techniques et les fiches de cours prêtes à l'emploi." },
  { q: "Puis-je adapter le matériel à chaque élève ?", a: "Oui. Le matériel vous fait gagner du temps de préparation, tout en vous laissant libre de l'adapter au niveau et au rythme de chaque élève." },
  { q: "Comment vais-je recevoir le matériel ?", a: "Juste après votre paiement, vous recevez un e-mail avec le lien pour télécharger les 2 livres et les 5 bonus en PDF." },
  { q: "Et si je ne suis pas entièrement satisfait ?", a: "Vous êtes couvert par notre garantie satisfait ou remboursé de 10 jours. Un simple e-mail à support@stockdigital.shop suffit, sans aucune question." },
];

export const beforeList = [
  "Des heures chaque semaine à chercher des tablatures et des fiches",
  "Des cours improvisés à la dernière minute",
  "Toujours les mêmes fiches d'accords",
  "Des élèves qui abandonnent avant leur premier morceau",
];

export const afterList = [
  "Vous ouvrez, vous choisissez, vous enseignez",
  "Du matériel prêt à imprimer pour chaque cours",
  "Des tablatures et des mélodies que vos élèves ont envie de jouer",
  "Assez de matériel pour couvrir tout votre trimestre",
];
